/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `ActYearRookieMatchServant.jce'
// **********************************************************************

var ActYearRookieMatch = ActYearRookieMatch || {};


ActYearRookieMatch.TemplateURI =
{
    PushAnchorPanel: 2020120201,
    PushAnchorUpdatePanel: 2020120202,
    PushHourRank: 2020120203,
    PushStageRank: 2020120204,
    PushPromoteResultPanel: 2020120205,
    PushHonorResultPanel: 2020120206,
    PushBattleAnnouncePanel: 2020120225,
    PushBattleUpdatePanel: 2020120226,
    PushBattlePanel: 2020120227,
    PushBattleResultPanel: 2020120228,
    PushBattleFansScorePanel: 202012029,
    PushTaskUpdate: 2020120231,
    PushTaskItemUpdate: 2020120232,
    PushClearPanel: 2020120299
};

ActYearRookieMatch.STAGE =
{
    kBeforeActivityStage: 0,
    kAuditionStage1: 1,
    kAuditionStage2: 2,
    kTop8Stage1: 3,
    kTop8Stage2: 4,
    kFinalStage: 5,
    kHonorStage: 6
};

ActYearRookieMatch.Group =
{
    Group_A: 1,
    Group_B: 2,
    Group_C: 3
};

ActYearRookieMatch.AreaType =
{
    AT_Game: 1,
    AT_Entertainment: 2
};

ActYearRookieMatch.PromoteType =
{
    PT_Promote: 1,
    PT_Eliminate: 2
};

ActYearRookieMatch.CType =
{
    E_CType_Content: 1,
    E_CType_Pic: 2
};

ActYearRookieMatch.TaskLevel =
{
    E_TaskLevel_B: 1,
    E_TaskLevel_A: 2,
    E_TaskLevel_S: 3,
    E_TaskLevel_SS: 4
};

ActYearRookieMatch.TaskState =
{
    E_TaskState_Doing: 0,
    E_TaskState_Done: 1
};

ActYearRookieMatch.TaskId =
{
    E_TaskId_PK: 1000
};

ActYearRookieMatch.XTestCmdReq = function () {
    this.lPid = 0;
    this.lUid = 0;
    this.sContent = "";
};
ActYearRookieMatch.XTestCmdReq.prototype._clone = function () { return new ActYearRookieMatch.XTestCmdReq(); }
ActYearRookieMatch.XTestCmdReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.XTestCmdReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.XTestCmdReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lUid);
    os.writeString(2, this.sContent);
};

ActYearRookieMatch.XTestCmdReq.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.lUid = is.readInt64(1, false, this.lUid);
    this.sContent = is.readString(2, false, this.sContent);
};

ActYearRookieMatch.XTestCmdRsp = function () {
    this.sRet = "";
};
ActYearRookieMatch.XTestCmdRsp.prototype._clone = function () { return new ActYearRookieMatch.XTestCmdRsp(); }
ActYearRookieMatch.XTestCmdRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.XTestCmdRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.XTestCmdRsp.prototype.writeTo = function (os) {
    os.writeString(0, this.sRet);
};

ActYearRookieMatch.XTestCmdRsp.prototype.readFrom = function (is) {
    this.sRet = is.readString(0, false, this.sRet);
};

ActYearRookieMatch.JumpChannel = function () {
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iGameId = 0;
    this.lYYId = 0;
    this.iRoomId = 0;
    this.bIsLive = 0;
};
ActYearRookieMatch.JumpChannel.prototype._clone = function () { return new ActYearRookieMatch.JumpChannel(); }
ActYearRookieMatch.JumpChannel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.JumpChannel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.JumpChannel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt32(3, this.iGameId);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iRoomId);
    os.writeInt32(6, this.bIsLive);
};

ActYearRookieMatch.JumpChannel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.lTid = is.readInt64(1, false, this.lTid);
    this.lSid = is.readInt64(2, false, this.lSid);
    this.iGameId = is.readInt32(3, false, this.iGameId);
    this.lYYId = is.readInt64(4, false, this.lYYId);
    this.iRoomId = is.readInt32(5, false, this.iRoomId);
    this.bIsLive = is.readInt32(6, false, this.bIsLive);
};

ActYearRookieMatch.RankItem = function () {
    this.tJump = new ActYearRookieMatch.JumpChannel();
    this.iRank = 0;
    this.lScore = 0;
    this.iPromoteStatus = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
};
ActYearRookieMatch.RankItem.prototype._clone = function () { return new ActYearRookieMatch.RankItem(); }
ActYearRookieMatch.RankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.RankItem.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.RankItem.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tJump);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeInt32(3, this.iPromoteStatus);
    os.writeString(4, this.sNickName);
    os.writeString(5, this.sLogoUrl);
};

ActYearRookieMatch.RankItem.prototype.readFrom = function (is) {
    this.tJump = is.readStruct(0, false, this.tJump);
    this.iRank = is.readInt32(1, false, this.iRank);
    this.lScore = is.readInt64(2, false, this.lScore);
    this.iPromoteStatus = is.readInt32(3, false, this.iPromoteStatus);
    this.sNickName = is.readString(4, false, this.sNickName);
    this.sLogoUrl = is.readString(5, false, this.sLogoUrl);
};

ActYearRookieMatch.AnchorUpdatePanel = function () {
    this.lPid = 0;
    this.iRank = 0;
    this.lScore = 0;
    this.iHourRank = 0;
    this.lHourScore = 0;
    this.iBuff = 0;
    this.iPromote = 0;
};
ActYearRookieMatch.AnchorUpdatePanel.prototype._clone = function () { return new ActYearRookieMatch.AnchorUpdatePanel(); }
ActYearRookieMatch.AnchorUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AnchorUpdatePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AnchorUpdatePanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeInt32(3, this.iHourRank);
    os.writeInt64(4, this.lHourScore);
    os.writeInt32(5, this.iBuff);
    os.writeInt32(6, this.iPromote);
};

ActYearRookieMatch.AnchorUpdatePanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.iRank = is.readInt32(1, false, this.iRank);
    this.lScore = is.readInt64(2, false, this.lScore);
    this.iHourRank = is.readInt32(3, false, this.iHourRank);
    this.lHourScore = is.readInt64(4, false, this.lHourScore);
    this.iBuff = is.readInt32(5, false, this.iBuff);
    this.iPromote = is.readInt32(6, false, this.iPromote);
};

ActYearRookieMatch.AnchorPanel = function () {
    this.tUpdate = new ActYearRookieMatch.AnchorUpdatePanel();
    this.iCurDay = 0;
    this.iMaxDay = 0;
    this.iStage = 0;
    this.sStageName = "";
    this.iArea = 0;
    this.sAreaName = "";
    this.sNickName = "";
    this.sLogoUrl = "";
    this.sPromoreDesc = "";
    this.iPromoteNum = 0;
    this.iGroupId = 0;
};
ActYearRookieMatch.AnchorPanel.prototype._clone = function () { return new ActYearRookieMatch.AnchorPanel(); }
ActYearRookieMatch.AnchorPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AnchorPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AnchorPanel.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tUpdate);
    os.writeInt32(1, this.iCurDay);
    os.writeInt32(2, this.iMaxDay);
    os.writeInt32(3, this.iStage);
    os.writeString(4, this.sStageName);
    os.writeInt32(5, this.iArea);
    os.writeString(6, this.sAreaName);
    os.writeString(7, this.sNickName);
    os.writeString(8, this.sLogoUrl);
    os.writeString(9, this.sPromoreDesc);
    os.writeInt32(10, this.iPromoteNum);
    os.writeInt32(11, this.iGroupId);
};

ActYearRookieMatch.AnchorPanel.prototype.readFrom = function (is) {
    this.tUpdate = is.readStruct(0, false, this.tUpdate);
    this.iCurDay = is.readInt32(1, false, this.iCurDay);
    this.iMaxDay = is.readInt32(2, false, this.iMaxDay);
    this.iStage = is.readInt32(3, false, this.iStage);
    this.sStageName = is.readString(4, false, this.sStageName);
    this.iArea = is.readInt32(5, false, this.iArea);
    this.sAreaName = is.readString(6, false, this.sAreaName);
    this.sNickName = is.readString(7, false, this.sNickName);
    this.sLogoUrl = is.readString(8, false, this.sLogoUrl);
    this.sPromoreDesc = is.readString(9, false, this.sPromoreDesc);
    this.iPromoteNum = is.readInt32(10, false, this.iPromoteNum);
    this.iGroupId = is.readInt32(11, false, this.iGroupId);
};

ActYearRookieMatch.HourRankPanel = function () {
    this.iAreaId = 0;
    this.iHour = 0;
    this.vRankList = new Taf.Vector(new ActYearRookieMatch.RankItem());
};
ActYearRookieMatch.HourRankPanel.prototype._clone = function () { return new ActYearRookieMatch.HourRankPanel(); }
ActYearRookieMatch.HourRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.HourRankPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.HourRankPanel.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iHour);
    os.writeVector(2, this.vRankList);
};

ActYearRookieMatch.HourRankPanel.prototype.readFrom = function (is) {
    this.iAreaId = is.readInt32(0, false, this.iAreaId);
    this.iHour = is.readInt32(1, false, this.iHour);
    this.vRankList = is.readVector(2, false, this.vRankList);
};

ActYearRookieMatch.StageRankPanel = function () {
    this.iAreaId = 0;
    this.vRankList = new Taf.Vector(new ActYearRookieMatch.RankItem());
    this.iGroupId = 0;
};
ActYearRookieMatch.StageRankPanel.prototype._clone = function () { return new ActYearRookieMatch.StageRankPanel(); }
ActYearRookieMatch.StageRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.StageRankPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.StageRankPanel.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iAreaId);
    os.writeVector(1, this.vRankList);
    os.writeInt32(2, this.iGroupId);
};

ActYearRookieMatch.StageRankPanel.prototype.readFrom = function (is) {
    this.iAreaId = is.readInt32(0, false, this.iAreaId);
    this.vRankList = is.readVector(1, false, this.vRankList);
    this.iGroupId = is.readInt32(2, false, this.iGroupId);
};

ActYearRookieMatch.PromoteResultPanel = function () {
    this.lPid = 0;
    this.iPromoteType = 0;
    this.iAreaId = 0;
    this.sAreaName = "";
    this.sDesc = "";
    this.sNickName = "";
    this.sLogoUrl = "";
};
ActYearRookieMatch.PromoteResultPanel.prototype._clone = function () { return new ActYearRookieMatch.PromoteResultPanel(); }
ActYearRookieMatch.PromoteResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.PromoteResultPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.PromoteResultPanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iPromoteType);
    os.writeInt32(2, this.iAreaId);
    os.writeString(3, this.sAreaName);
    os.writeString(4, this.sDesc);
    os.writeString(5, this.sNickName);
    os.writeString(6, this.sLogoUrl);
};

ActYearRookieMatch.PromoteResultPanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.iPromoteType = is.readInt32(1, false, this.iPromoteType);
    this.iAreaId = is.readInt32(2, false, this.iAreaId);
    this.sAreaName = is.readString(3, false, this.sAreaName);
    this.sDesc = is.readString(4, false, this.sDesc);
    this.sNickName = is.readString(5, false, this.sNickName);
    this.sLogoUrl = is.readString(6, false, this.sLogoUrl);
};

ActYearRookieMatch.PresenterInfo = function () {
    this.lPid = 0;
    this.iRank = 0;
    this.sLogoUrl = "";
    this.sNickName = "";
    this.tJump = new ActYearRookieMatch.JumpChannel();
};
ActYearRookieMatch.PresenterInfo.prototype._clone = function () { return new ActYearRookieMatch.PresenterInfo(); }
ActYearRookieMatch.PresenterInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.PresenterInfo.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.PresenterInfo.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iRank);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sNickName);
    os.writeStruct(4, this.tJump);
};

ActYearRookieMatch.PresenterInfo.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.iRank = is.readInt32(1, false, this.iRank);
    this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
    this.sNickName = is.readString(3, false, this.sNickName);
    this.tJump = is.readStruct(4, false, this.tJump);
};

ActYearRookieMatch.HonorResultPanel = function () {
    this.iAreaId = 0;
    this.sAreaName = "";
    this.vWinnerList = new Taf.Vector(new ActYearRookieMatch.PresenterInfo());
};
ActYearRookieMatch.HonorResultPanel.prototype._clone = function () { return new ActYearRookieMatch.HonorResultPanel(); }
ActYearRookieMatch.HonorResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.HonorResultPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.HonorResultPanel.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iAreaId);
    os.writeString(1, this.sAreaName);
    os.writeVector(2, this.vWinnerList);
};

ActYearRookieMatch.HonorResultPanel.prototype.readFrom = function (is) {
    this.iAreaId = is.readInt32(0, false, this.iAreaId);
    this.sAreaName = is.readString(1, false, this.sAreaName);
    this.vWinnerList = is.readVector(2, false, this.vWinnerList);
};

ActYearRookieMatch.ClearPanel = function () {
    this.lPid = 0;
    this.iActivityId = 0;
};
ActYearRookieMatch.ClearPanel.prototype._clone = function () { return new ActYearRookieMatch.ClearPanel(); }
ActYearRookieMatch.ClearPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.ClearPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.ClearPanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iActivityId);
};

ActYearRookieMatch.ClearPanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.iActivityId = is.readInt32(1, false, this.iActivityId);
};

ActYearRookieMatch.BattleMember = function () {
    this.tJump = new ActYearRookieMatch.JumpChannel();
    this.sLogo = "";
    this.sNickName = "";
    this.iLeader = 0;
};
ActYearRookieMatch.BattleMember.prototype._clone = function () { return new ActYearRookieMatch.BattleMember(); }
ActYearRookieMatch.BattleMember.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattleMember.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattleMember.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sLogo);
    os.writeString(2, this.sNickName);
    os.writeInt32(3, this.iLeader);
};

ActYearRookieMatch.BattleMember.prototype.readFrom = function (is) {
    this.tJump = is.readStruct(0, false, this.tJump);
    this.sLogo = is.readString(1, false, this.sLogo);
    this.sNickName = is.readString(2, false, this.sNickName);
    this.iLeader = is.readInt32(3, false, this.iLeader);
};

ActYearRookieMatch.BattleUpdatePanel = function () {
    this.lPid = 0;
    this.iSide = 0;
    this.iLeftTime = 0;
    this.iKillTime = 0;
    this.lAttScore = 0;
    this.lDefScore = 0;
    this.mAttScore = new Taf.Map(new Taf.INT64(), new Taf.INT64());
    this.mDefScore = new Taf.Map(new Taf.INT64(), new Taf.INT64());
    this.iAttPkBuff = 0;
    this.iDefPkBuff = 0;
};
ActYearRookieMatch.BattleUpdatePanel.prototype._clone = function () { return new ActYearRookieMatch.BattleUpdatePanel(); }
ActYearRookieMatch.BattleUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattleUpdatePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattleUpdatePanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iSide);
    os.writeInt32(2, this.iLeftTime);
    os.writeInt32(3, this.iKillTime);
    os.writeInt64(4, this.lAttScore);
    os.writeInt64(5, this.lDefScore);
    os.writeMap(6, this.mAttScore);
    os.writeMap(7, this.mDefScore);
    os.writeInt32(8, this.iAttPkBuff);
    os.writeInt32(9, this.iDefPkBuff);
};

ActYearRookieMatch.BattleUpdatePanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.iSide = is.readInt32(1, false, this.iSide);
    this.iLeftTime = is.readInt32(2, false, this.iLeftTime);
    this.iKillTime = is.readInt32(3, false, this.iKillTime);
    this.lAttScore = is.readInt64(4, false, this.lAttScore);
    this.lDefScore = is.readInt64(5, false, this.lDefScore);
    this.mAttScore = is.readMap(6, false, this.mAttScore);
    this.mDefScore = is.readMap(7, false, this.mDefScore);
    this.iAttPkBuff = is.readInt32(8, false, this.iAttPkBuff);
    this.iDefPkBuff = is.readInt32(9, false, this.iDefPkBuff);
};

ActYearRookieMatch.BattlePanel = function () {
    this.iPKType = 0;
    this.tUpdate = new ActYearRookieMatch.BattleUpdatePanel();
    this.vAttMembers = new Taf.Vector(new ActYearRookieMatch.BattleMember());
    this.vDefMembers = new Taf.Vector(new ActYearRookieMatch.BattleMember());
    this.iAreaId = 0;
    this.lAttGetScore = 0;
    this.lDefLoseScore = 0;
};
ActYearRookieMatch.BattlePanel.prototype._clone = function () { return new ActYearRookieMatch.BattlePanel(); }
ActYearRookieMatch.BattlePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattlePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattlePanel.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iPKType);
    os.writeStruct(1, this.tUpdate);
    os.writeVector(2, this.vAttMembers);
    os.writeVector(3, this.vDefMembers);
    os.writeInt32(4, this.iAreaId);
    os.writeInt64(5, this.lAttGetScore);
    os.writeInt64(6, this.lDefLoseScore);
};

ActYearRookieMatch.BattlePanel.prototype.readFrom = function (is) {
    this.iPKType = is.readInt32(0, false, this.iPKType);
    this.tUpdate = is.readStruct(1, false, this.tUpdate);
    this.vAttMembers = is.readVector(2, false, this.vAttMembers);
    this.vDefMembers = is.readVector(3, false, this.vDefMembers);
    this.iAreaId = is.readInt32(4, false, this.iAreaId);
    this.lAttGetScore = is.readInt64(5, false, this.lAttGetScore);
    this.lDefLoseScore = is.readInt64(6, false, this.lDefLoseScore);
};

ActYearRookieMatch.BattleAnnouncePanel = function () {
    this.tBattle = new ActYearRookieMatch.BattlePanel();
    this.iBuffButton = 0;
};
ActYearRookieMatch.BattleAnnouncePanel.prototype._clone = function () { return new ActYearRookieMatch.BattleAnnouncePanel(); }
ActYearRookieMatch.BattleAnnouncePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattleAnnouncePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattleAnnouncePanel.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iBuffButton);
};

ActYearRookieMatch.BattleAnnouncePanel.prototype.readFrom = function (is) {
    this.tBattle = is.readStruct(0, false, this.tBattle);
    this.iBuffButton = is.readInt32(1, false, this.iBuffButton);
};

ActYearRookieMatch.BattleResultPanel = function () {
    this.tBattle = new ActYearRookieMatch.BattlePanel();
    this.iResult = 0;
    this.lDeltaScore = 0;
    this.lReturnScore = 0;
};
ActYearRookieMatch.BattleResultPanel.prototype._clone = function () { return new ActYearRookieMatch.BattleResultPanel(); }
ActYearRookieMatch.BattleResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattleResultPanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattleResultPanel.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iResult);
    os.writeInt64(2, this.lDeltaScore);
    os.writeInt64(3, this.lReturnScore);
};

ActYearRookieMatch.BattleResultPanel.prototype.readFrom = function (is) {
    this.tBattle = is.readStruct(0, false, this.tBattle);
    this.iResult = is.readInt32(1, false, this.iResult);
    this.lDeltaScore = is.readInt64(2, false, this.lDeltaScore);
    this.lReturnScore = is.readInt64(3, false, this.lReturnScore);
};

ActYearRookieMatch.EnablePkBuffReq = function () {
    this.tPid = new HUYA.UserId();
};
ActYearRookieMatch.EnablePkBuffReq.prototype._clone = function () { return new ActYearRookieMatch.EnablePkBuffReq(); }
ActYearRookieMatch.EnablePkBuffReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.EnablePkBuffReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.EnablePkBuffReq.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tPid);
};

ActYearRookieMatch.EnablePkBuffReq.prototype.readFrom = function (is) {
    this.tPid = is.readStruct(0, false, this.tPid);
};

ActYearRookieMatch.EnablePkBuffRsp = function () {
    this.iRet = 0;
    this.sErrMsg = "";
};
ActYearRookieMatch.EnablePkBuffRsp.prototype._clone = function () { return new ActYearRookieMatch.EnablePkBuffRsp(); }
ActYearRookieMatch.EnablePkBuffRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.EnablePkBuffRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.EnablePkBuffRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sErrMsg);
};

ActYearRookieMatch.EnablePkBuffRsp.prototype.readFrom = function (is) {
    this.iRet = is.readInt32(0, false, this.iRet);
    this.sErrMsg = is.readString(1, false, this.sErrMsg);
};

ActYearRookieMatch.FansScore = function () {
    this.lUid = 0;
    this.sNickName = "";
    this.lScore = 0;
};
ActYearRookieMatch.FansScore.prototype._clone = function () { return new ActYearRookieMatch.FansScore(); }
ActYearRookieMatch.FansScore.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.FansScore.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.FansScore.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt64(3, this.lScore);
};

ActYearRookieMatch.FansScore.prototype.readFrom = function (is) {
    this.lUid = is.readInt64(0, false, this.lUid);
    this.sNickName = is.readString(1, false, this.sNickName);
    this.lScore = is.readInt64(3, false, this.lScore);
};

ActYearRookieMatch.BattleFansScorePanel = function () {
    this.lPid = 0;
    this.vAttScores = new Taf.Vector(new ActYearRookieMatch.FansScore());
    this.vDefScores = new Taf.Vector(new ActYearRookieMatch.FansScore());
};
ActYearRookieMatch.BattleFansScorePanel.prototype._clone = function () { return new ActYearRookieMatch.BattleFansScorePanel(); }
ActYearRookieMatch.BattleFansScorePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.BattleFansScorePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.BattleFansScorePanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeVector(1, this.vAttScores);
    os.writeVector(2, this.vDefScores);
};

ActYearRookieMatch.BattleFansScorePanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.vAttScores = is.readVector(1, false, this.vAttScores);
    this.vDefScores = is.readVector(2, false, this.vDefScores);
};

ActYearRookieMatch.AttackReq = function () {
    this.tAttackId = new HUYA.UserId();
    this.lDefPid = 0;
};
ActYearRookieMatch.AttackReq.prototype._clone = function () { return new ActYearRookieMatch.AttackReq(); }
ActYearRookieMatch.AttackReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AttackReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AttackReq.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tAttackId);
    os.writeInt64(1, this.lDefPid);
};

ActYearRookieMatch.AttackReq.prototype.readFrom = function (is) {
    this.tAttackId = is.readStruct(0, false, this.tAttackId);
    this.lDefPid = is.readInt64(1, false, this.lDefPid);
};

ActYearRookieMatch.AttackRsp = function () {
    this.iResult = 0;
    this.lAttPid = 0;
    this.lDefPid = 0;
    this.sDesc1 = "";
    this.sDesc2 = "";
};
ActYearRookieMatch.AttackRsp.prototype._clone = function () { return new ActYearRookieMatch.AttackRsp(); }
ActYearRookieMatch.AttackRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AttackRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AttackRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iResult);
    os.writeInt64(1, this.lAttPid);
    os.writeInt64(2, this.lDefPid);
    os.writeString(3, this.sDesc1);
    os.writeString(4, this.sDesc2);
};

ActYearRookieMatch.AttackRsp.prototype.readFrom = function (is) {
    this.iResult = is.readInt32(0, false, this.iResult);
    this.lAttPid = is.readInt64(1, false, this.lAttPid);
    this.lDefPid = is.readInt64(2, false, this.lDefPid);
    this.sDesc1 = is.readString(3, false, this.sDesc1);
    this.sDesc2 = is.readString(4, false, this.sDesc2);
};

ActYearRookieMatch.AttackSearchItem = function () {
    this.lPid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.lScore = 0;
    this.iAttTime = 0;
    this.iDefTime = 0;
    this.iRevege = 0;
};
ActYearRookieMatch.AttackSearchItem.prototype._clone = function () { return new ActYearRookieMatch.AttackSearchItem(); }
ActYearRookieMatch.AttackSearchItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AttackSearchItem.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AttackSearchItem.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt64(3, this.lScore);
    os.writeInt32(4, this.iAttTime);
    os.writeInt32(5, this.iDefTime);
    os.writeInt32(6, this.iRevege);
};

ActYearRookieMatch.AttackSearchItem.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.sNickName = is.readString(1, false, this.sNickName);
    this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
    this.lScore = is.readInt64(3, false, this.lScore);
    this.iAttTime = is.readInt32(4, false, this.iAttTime);
    this.iDefTime = is.readInt32(5, false, this.iDefTime);
    this.iRevege = is.readInt32(6, false, this.iRevege);
};

ActYearRookieMatch.AttackSearchReq = function () {
    this.lPid = 0;
    this.sSearchName = "";
};
ActYearRookieMatch.AttackSearchReq.prototype._clone = function () { return new ActYearRookieMatch.AttackSearchReq(); }
ActYearRookieMatch.AttackSearchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AttackSearchReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AttackSearchReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sSearchName);
};

ActYearRookieMatch.AttackSearchReq.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.sSearchName = is.readString(1, false, this.sSearchName);
};

ActYearRookieMatch.AttackSearchRsp = function () {
    this.vItems = new Taf.Vector(new ActYearRookieMatch.AttackSearchItem());
};
ActYearRookieMatch.AttackSearchRsp.prototype._clone = function () { return new ActYearRookieMatch.AttackSearchRsp(); }
ActYearRookieMatch.AttackSearchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AttackSearchRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AttackSearchRsp.prototype.writeTo = function (os) {
    os.writeVector(0, this.vItems);
};

ActYearRookieMatch.AttackSearchRsp.prototype.readFrom = function (is) {
    this.vItems = is.readVector(0, false, this.vItems);
};

ActYearRookieMatch.Context = function () {
    this.sWord = "";
    this.iColor = 0;
    this.iContextType = 0;
};
ActYearRookieMatch.Context.prototype._clone = function () { return new ActYearRookieMatch.Context(); }
ActYearRookieMatch.Context.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.Context.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.Context.prototype.writeTo = function (os) {
    os.writeString(0, this.sWord);
    os.writeInt32(1, this.iColor);
    os.writeInt32(2, this.iContextType);
};

ActYearRookieMatch.Context.prototype.readFrom = function (is) {
    this.sWord = is.readString(0, false, this.sWord);
    this.iColor = is.readInt32(1, false, this.iColor);
    this.iContextType = is.readInt32(2, false, this.iContextType);
};

ActYearRookieMatch.UserTaskState = function () {
    this.lTaskId = 0;
    this.sTaskDesc = "";
    this.iState = 0;
    this.iTaskLevel = 0;
    this.iNowExperience = 0;
    this.iNextExperience = 0;
};
ActYearRookieMatch.UserTaskState.prototype._clone = function () { return new ActYearRookieMatch.UserTaskState(); }
ActYearRookieMatch.UserTaskState.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.UserTaskState.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.UserTaskState.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lTaskId);
    os.writeString(1, this.sTaskDesc);
    os.writeInt32(2, this.iState);
    os.writeInt32(3, this.iTaskLevel);
    os.writeInt32(4, this.iNowExperience);
    os.writeInt32(5, this.iNextExperience);
};

ActYearRookieMatch.UserTaskState.prototype.readFrom = function (is) {
    this.lTaskId = is.readInt64(0, false, this.lTaskId);
    this.sTaskDesc = is.readString(1, false, this.sTaskDesc);
    this.iState = is.readInt32(2, false, this.iState);
    this.iTaskLevel = is.readInt32(3, false, this.iTaskLevel);
    this.iNowExperience = is.readInt32(4, false, this.iNowExperience);
    this.iNextExperience = is.readInt32(5, false, this.iNextExperience);
};

ActYearRookieMatch.TaskUpdatePanel = function () {
    this.lPid = 0;
    this.lTopTaskId = 0;
    this.vTaskList = new Taf.Vector(new ActYearRookieMatch.UserTaskState());
    this.mpFinshedNum = new Taf.Map(new Taf.INT32(), new Taf.INT32());
    this.vAward = new Taf.Vector(new ActYearRookieMatch.Context());
};
ActYearRookieMatch.TaskUpdatePanel.prototype._clone = function () { return new ActYearRookieMatch.TaskUpdatePanel(); }
ActYearRookieMatch.TaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.TaskUpdatePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.TaskUpdatePanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTopTaskId);
    os.writeVector(2, this.vTaskList);
    os.writeMap(3, this.mpFinshedNum);
    os.writeVector(4, this.vAward);
};

ActYearRookieMatch.TaskUpdatePanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.lTopTaskId = is.readInt64(1, false, this.lTopTaskId);
    this.vTaskList = is.readVector(2, false, this.vTaskList);
    this.mpFinshedNum = is.readMap(3, false, this.mpFinshedNum);
    this.vAward = is.readVector(4, false, this.vAward);
};

ActYearRookieMatch.SingleTaskUpdatePanel = function () {
    this.lPid = 0;
    this.tTaskItem = new ActYearRookieMatch.UserTaskState();
};
ActYearRookieMatch.SingleTaskUpdatePanel.prototype._clone = function () { return new ActYearRookieMatch.SingleTaskUpdatePanel(); }
ActYearRookieMatch.SingleTaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.SingleTaskUpdatePanel.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.SingleTaskUpdatePanel.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeStruct(1, this.tTaskItem);
};

ActYearRookieMatch.SingleTaskUpdatePanel.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.tTaskItem = is.readStruct(1, false, this.tTaskItem);
};

ActYearRookieMatch.TopTaskReq = function () {
    this.lPid = 0;
    this.lTaskId = 0;
};
ActYearRookieMatch.TopTaskReq.prototype._clone = function () { return new ActYearRookieMatch.TopTaskReq(); }
ActYearRookieMatch.TopTaskReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.TopTaskReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.TopTaskReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTaskId);
};

ActYearRookieMatch.TopTaskReq.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.lTaskId = is.readInt64(1, false, this.lTaskId);
};

ActYearRookieMatch.TopTaskRsp = function () {
    this.iRet = 0;
    this.sMsg = "";
    this.tUserTaskState = new ActYearRookieMatch.UserTaskState();
};
ActYearRookieMatch.TopTaskRsp.prototype._clone = function () { return new ActYearRookieMatch.TopTaskRsp(); }
ActYearRookieMatch.TopTaskRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.TopTaskRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.TopTaskRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
    os.writeStruct(2, this.tUserTaskState);
};

ActYearRookieMatch.TopTaskRsp.prototype.readFrom = function (is) {
    this.iRet = is.readInt32(0, false, this.iRet);
    this.sMsg = is.readString(1, false, this.sMsg);
    this.tUserTaskState = is.readStruct(2, false, this.tUserTaskState);
};

ActYearRookieMatch.GetStageReq = function () {
    this.iActId = 0;
    this.lPid = 0;
};
ActYearRookieMatch.GetStageReq.prototype._clone = function () { return new ActYearRookieMatch.GetStageReq(); }
ActYearRookieMatch.GetStageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetStageReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetStageReq.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iActId);
    os.writeInt64(1, this.lPid);
};

ActYearRookieMatch.GetStageReq.prototype.readFrom = function (is) {
    this.iActId = is.readInt32(0, false, this.iActId);
    this.lPid = is.readInt64(1, false, this.lPid);
};

ActYearRookieMatch.GetStageRsp = function () {
    this.iStage = 0;
    this.iDay = 0;
    this.iArea = 0;
};
ActYearRookieMatch.GetStageRsp.prototype._clone = function () { return new ActYearRookieMatch.GetStageRsp(); }
ActYearRookieMatch.GetStageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetStageRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetStageRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iDay);
    os.writeInt32(2, this.iArea);
};

ActYearRookieMatch.GetStageRsp.prototype.readFrom = function (is) {
    this.iStage = is.readInt32(0, false, this.iStage);
    this.iDay = is.readInt32(1, false, this.iDay);
    this.iArea = is.readInt32(2, false, this.iArea);
};

ActYearRookieMatch.PresenterBase = function () {
    this.tJump = new ActYearRookieMatch.JumpChannel();
    this.sNickName = "";
    this.sLogoUrl = "";
};
ActYearRookieMatch.PresenterBase.prototype._clone = function () { return new ActYearRookieMatch.PresenterBase(); }
ActYearRookieMatch.PresenterBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.PresenterBase.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.PresenterBase.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
};

ActYearRookieMatch.PresenterBase.prototype.readFrom = function (is) {
    this.tJump = is.readStruct(0, false, this.tJump);
    this.sNickName = is.readString(1, false, this.sNickName);
    this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
};

ActYearRookieMatch.GetHourRankReq = function () {
    this.iActId = 0;
    this.iStage = 0;
    this.lPid = 0;
    this.iAreaId = 0;
};
ActYearRookieMatch.GetHourRankReq.prototype._clone = function () { return new ActYearRookieMatch.GetHourRankReq(); }
ActYearRookieMatch.GetHourRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetHourRankReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetHourRankReq.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iStage);
    os.writeInt64(2, this.lPid);
    os.writeInt32(3, this.iAreaId);
};

ActYearRookieMatch.GetHourRankReq.prototype.readFrom = function (is) {
    this.iActId = is.readInt32(0, false, this.iActId);
    this.iStage = is.readInt32(1, false, this.iStage);
    this.lPid = is.readInt64(2, false, this.lPid);
    this.iAreaId = is.readInt32(3, false, this.iAreaId);
};

ActYearRookieMatch.HourTopItem = function () {
    this.tJump = new ActYearRookieMatch.JumpChannel();
    this.sNickName = "";
    this.sLogoUrl = "";
    this.sDesc = "";
};
ActYearRookieMatch.HourTopItem.prototype._clone = function () { return new ActYearRookieMatch.HourTopItem(); }
ActYearRookieMatch.HourTopItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.HourTopItem.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.HourTopItem.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sDesc);
};

ActYearRookieMatch.HourTopItem.prototype.readFrom = function (is) {
    this.tJump = is.readStruct(0, false, this.tJump);
    this.sNickName = is.readString(1, false, this.sNickName);
    this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
    this.sDesc = is.readString(3, false, this.sDesc);
};

ActYearRookieMatch.GetHourRankRsp = function () {
    this.iCurStage = 0;
    this.vRank = new Taf.Vector(new ActYearRookieMatch.RankItem());
    this.vHourRank = new Taf.Vector(new ActYearRookieMatch.HourTopItem());
    this.tPidRank = new ActYearRookieMatch.RankItem();
    this.iHour = 0;
};
ActYearRookieMatch.GetHourRankRsp.prototype._clone = function () { return new ActYearRookieMatch.GetHourRankRsp(); }
ActYearRookieMatch.GetHourRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetHourRankRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetHourRankRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iCurStage);
    os.writeVector(1, this.vRank);
    os.writeVector(2, this.vHourRank);
    os.writeStruct(3, this.tPidRank);
    os.writeInt32(4, this.iHour);
};

ActYearRookieMatch.GetHourRankRsp.prototype.readFrom = function (is) {
    this.iCurStage = is.readInt32(0, false, this.iCurStage);
    this.vRank = is.readVector(1, false, this.vRank);
    this.vHourRank = is.readVector(2, false, this.vHourRank);
    this.tPidRank = is.readStruct(3, false, this.tPidRank);
    this.iHour = is.readInt32(4, false, this.iHour);
};

ActYearRookieMatch.GetRichRankReq = function () {
    this.iActId = 0;
    this.iAreaId = 0;
};
ActYearRookieMatch.GetRichRankReq.prototype._clone = function () { return new ActYearRookieMatch.GetRichRankReq(); }
ActYearRookieMatch.GetRichRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetRichRankReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetRichRankReq.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iAreaId);
};

ActYearRookieMatch.GetRichRankReq.prototype.readFrom = function (is) {
    this.iActId = is.readInt32(0, false, this.iActId);
    this.iAreaId = is.readInt32(1, false, this.iAreaId);
};

ActYearRookieMatch.GetRichRankRsp = function () {
    this.vRank = new Taf.Vector(new ActYearRookieMatch.RankItem());
};
ActYearRookieMatch.GetRichRankRsp.prototype._clone = function () { return new ActYearRookieMatch.GetRichRankRsp(); }
ActYearRookieMatch.GetRichRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetRichRankRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetRichRankRsp.prototype.writeTo = function (os) {
    os.writeVector(0, this.vRank);
};

ActYearRookieMatch.GetRichRankRsp.prototype.readFrom = function (is) {
    this.vRank = is.readVector(0, false, this.vRank);
};

ActYearRookieMatch.GetAuditionRankReq = function () {
    this.iActId = 0;
    this.iAreaId = 0;
    this.iStage = 0;
    this.lPid = 0;
};
ActYearRookieMatch.GetAuditionRankReq.prototype._clone = function () { return new ActYearRookieMatch.GetAuditionRankReq(); }
ActYearRookieMatch.GetAuditionRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetAuditionRankReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetAuditionRankReq.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iAreaId);
    os.writeInt32(2, this.iStage);
    os.writeInt64(3, this.lPid);
};

ActYearRookieMatch.GetAuditionRankReq.prototype.readFrom = function (is) {
    this.iActId = is.readInt32(0, false, this.iActId);
    this.iAreaId = is.readInt32(1, false, this.iAreaId);
    this.iStage = is.readInt32(2, false, this.iStage);
    this.lPid = is.readInt64(3, false, this.lPid);
};

ActYearRookieMatch.GetAuditionRankRsp = function () {
    this.tPanel = new ActYearRookieMatch.StageRankPanel();
    this.tPidRank = new ActYearRookieMatch.RankItem();
};
ActYearRookieMatch.GetAuditionRankRsp.prototype._clone = function () { return new ActYearRookieMatch.GetAuditionRankRsp(); }
ActYearRookieMatch.GetAuditionRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetAuditionRankRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetAuditionRankRsp.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tPanel);
    os.writeStruct(1, this.tPidRank);
};

ActYearRookieMatch.GetAuditionRankRsp.prototype.readFrom = function (is) {
    this.tPanel = is.readStruct(0, false, this.tPanel);
    this.tPidRank = is.readStruct(1, false, this.tPidRank);
};

ActYearRookieMatch.GetStarEliminateRankReq = function () {
    this.iActId = 0;
    this.iAreaId = 0;
};
ActYearRookieMatch.GetStarEliminateRankReq.prototype._clone = function () { return new ActYearRookieMatch.GetStarEliminateRankReq(); }
ActYearRookieMatch.GetStarEliminateRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetStarEliminateRankReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetStarEliminateRankReq.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iAreaId);
};

ActYearRookieMatch.GetStarEliminateRankReq.prototype.readFrom = function (is) {
    this.iActId = is.readInt32(0, false, this.iActId);
    this.iAreaId = is.readInt32(1, false, this.iAreaId);
};

ActYearRookieMatch.GetStarEliminateRankRsp = function () {
    this.tPanelA = new ActYearRookieMatch.StageRankPanel();
    this.tPanelB = new ActYearRookieMatch.StageRankPanel();
    this.tPanelC = new ActYearRookieMatch.StageRankPanel();
};
ActYearRookieMatch.GetStarEliminateRankRsp.prototype._clone = function () { return new ActYearRookieMatch.GetStarEliminateRankRsp(); }
ActYearRookieMatch.GetStarEliminateRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.GetStarEliminateRankRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.GetStarEliminateRankRsp.prototype.writeTo = function (os) {
    os.writeStruct(0, this.tPanelA);
    os.writeStruct(1, this.tPanelB);
    os.writeStruct(2, this.tPanelC);
};

ActYearRookieMatch.GetStarEliminateRankRsp.prototype.readFrom = function (is) {
    this.tPanelA = is.readStruct(0, false, this.tPanelA);
    this.tPanelB = is.readStruct(1, false, this.tPanelB);
    this.tPanelC = is.readStruct(2, false, this.tPanelC);
};

ActYearRookieMatch.SearchHelperReq = function () {
    this.lHyId = 0;
    this.lPid = 0;
    this.sHyId = "";
};
ActYearRookieMatch.SearchHelperReq.prototype._clone = function () { return new ActYearRookieMatch.SearchHelperReq(); }
ActYearRookieMatch.SearchHelperReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.SearchHelperReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.SearchHelperReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lHyId);
    os.writeInt64(1, this.lPid);
    os.writeString(2, this.sHyId);
};

ActYearRookieMatch.SearchHelperReq.prototype.readFrom = function (is) {
    this.lHyId = is.readInt64(0, false, this.lHyId);
    this.lPid = is.readInt64(1, false, this.lPid);
    this.sHyId = is.readString(2, false, this.sHyId);
};

ActYearRookieMatch.SearchHelperRsp = function () {
    this.ifind = 0;
    this.iRet = 0;
    this.tInfo = new ActYearRookieMatch.PresenterBase();
};
ActYearRookieMatch.SearchHelperRsp.prototype._clone = function () { return new ActYearRookieMatch.SearchHelperRsp(); }
ActYearRookieMatch.SearchHelperRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.SearchHelperRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.SearchHelperRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.ifind);
    os.writeInt32(1, this.iRet);
    os.writeStruct(2, this.tInfo);
};

ActYearRookieMatch.SearchHelperRsp.prototype.readFrom = function (is) {
    this.ifind = is.readInt32(0, false, this.ifind);
    this.iRet = is.readInt32(1, false, this.iRet);
    this.tInfo = is.readStruct(2, false, this.tInfo);
};

ActYearRookieMatch.InvitePresenterReq = function () {
    this.lInvitedPid = 0;
    this.lPid = 0;
};
ActYearRookieMatch.InvitePresenterReq.prototype._clone = function () { return new ActYearRookieMatch.InvitePresenterReq(); }
ActYearRookieMatch.InvitePresenterReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.InvitePresenterReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.InvitePresenterReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lInvitedPid);
    os.writeInt64(1, this.lPid);
};

ActYearRookieMatch.InvitePresenterReq.prototype.readFrom = function (is) {
    this.lInvitedPid = is.readInt64(0, false, this.lInvitedPid);
    this.lPid = is.readInt64(1, false, this.lPid);
};

ActYearRookieMatch.InvitePresenterRsp = function () {
    this.iRet = 0;
};
ActYearRookieMatch.InvitePresenterRsp.prototype._clone = function () { return new ActYearRookieMatch.InvitePresenterRsp(); }
ActYearRookieMatch.InvitePresenterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.InvitePresenterRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.InvitePresenterRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iRet);
};

ActYearRookieMatch.InvitePresenterRsp.prototype.readFrom = function (is) {
    this.iRet = is.readInt32(0, false, this.iRet);
};

ActYearRookieMatch.AcceptInviteReq = function () {
    this.lPid = 0;
    this.lInvitedPid = 0;
};
ActYearRookieMatch.AcceptInviteReq.prototype._clone = function () { return new ActYearRookieMatch.AcceptInviteReq(); }
ActYearRookieMatch.AcceptInviteReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AcceptInviteReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AcceptInviteReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lInvitedPid);
};

ActYearRookieMatch.AcceptInviteReq.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
    this.lInvitedPid = is.readInt64(1, false, this.lInvitedPid);
};

ActYearRookieMatch.AcceptInviteRsp = function () {
    this.iRet = 0;
};
ActYearRookieMatch.AcceptInviteRsp.prototype._clone = function () { return new ActYearRookieMatch.AcceptInviteRsp(); }
ActYearRookieMatch.AcceptInviteRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.AcceptInviteRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.AcceptInviteRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iRet);
};

ActYearRookieMatch.AcceptInviteRsp.prototype.readFrom = function (is) {
    this.iRet = is.readInt32(0, false, this.iRet);
};

ActYearRookieMatch.getSignUpPageReq = function () {
    this.lPid = 0;
};
ActYearRookieMatch.getSignUpPageReq.prototype._clone = function () { return new ActYearRookieMatch.getSignUpPageReq(); }
ActYearRookieMatch.getSignUpPageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.getSignUpPageReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.getSignUpPageReq.prototype.writeTo = function (os) {
    os.writeInt64(0, this.lPid);
};

ActYearRookieMatch.getSignUpPageReq.prototype.readFrom = function (is) {
    this.lPid = is.readInt64(0, false, this.lPid);
};

ActYearRookieMatch.getSignUpPageRsp = function () {
    this.iContestant = 0;
    this.iTeamup = 0;
    this.tRookie = new ActYearRookieMatch.PresenterBase();
    this.tHelper = new ActYearRookieMatch.PresenterBase();
    this.vMembers = new Taf.Vector(new ActYearRookieMatch.PresenterBase());
};
ActYearRookieMatch.getSignUpPageRsp.prototype._clone = function () { return new ActYearRookieMatch.getSignUpPageRsp(); }
ActYearRookieMatch.getSignUpPageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActYearRookieMatch.getSignUpPageRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActYearRookieMatch.getSignUpPageRsp.prototype.writeTo = function (os) {
    os.writeInt32(0, this.iContestant);
    os.writeInt32(1, this.iTeamup);
    os.writeStruct(2, this.tRookie);
    os.writeStruct(3, this.tHelper);
    os.writeVector(4, this.vMembers);
};

ActYearRookieMatch.getSignUpPageRsp.prototype.readFrom = function (is) {
    this.iContestant = is.readInt32(0, false, this.iContestant);
    this.iTeamup = is.readInt32(1, false, this.iTeamup);
    this.tRookie = is.readStruct(2, false, this.tRookie);
    this.tHelper = is.readStruct(3, false, this.tHelper);
    this.vMembers = is.readVector(4, false, this.vMembers);
};

var HUYA = HUYA || {};


export default ActYearRookieMatch;
